import { executeQuerySideload } from "../helpers/studyPlan"
import { GET_DATA, GET_DEFINITION, CSV_DOWNLOAD } from "./viewQueries"

export interface ViewQueryInput {
  name: string
  filters?: {
    name: string
    values?: string[]
    startDate?: string
    endDate?: string
  }[]
  sort?: {
    name: string
    direction: string
  }[]
  page?: number
  pageSize?: number
}

export interface ViewQueryOutput {
  rows: {
    data: {
      name: string
      value: string
    }[]
  }[]
  totalCount: number
}

export interface ViewDownloadInput {
  name: string
  filters?: {
    name: string
    values?: string[]
    startDate?: string
    endDate?: string
  }[]
}

export interface ViewDownloadOutput {
  output: string
}

export async function getData(
  data: ViewQueryInput
): Promise<ViewQueryOutput> {
  const response = await executeQuerySideload(GET_DATA, {
    data
  })
  return response.views?.getData
}

export async function getDefinition(
  name: string
): Promise<any> {
  const response = await executeQuerySideload(GET_DEFINITION, {
    data: {
      name,
    }
  })
  return response.views?.getDefinition
}

export async function csvDownload(
  data: ViewDownloadInput
): Promise<ViewDownloadOutput> {
  const response = await executeQuerySideload(CSV_DOWNLOAD, {
    data
  })
  return response.views?.csvDownload
}

